import { isHeroBrandEnabled } from './heroBrandUtils';

export const localStorageKeysMap = {
  feedbackError: 'feedbackError'
};

const FEEDBACK_STORAGE_PREFIX = 'feedback_';

const FEEDBACK_STORAGE_KEYS = [
  'userId',
  'chatroomId',
  'prebookingId',
  'invoiceRef',
  'invoiceUserGroupId'
];

export const getFromStorageOrFallback = (key, fallback = '') => {
  return localStorage.getItem(FEEDBACK_STORAGE_PREFIX + key) || fallback;
};

export const saveToStorage = (key, value) => {
  if (value !== undefined && value !== null) {
    localStorage.setItem(FEEDBACK_STORAGE_PREFIX + key, value);
  }
};

export const removeFromStorage = (key) => {
  localStorage.removeItem(FEEDBACK_STORAGE_PREFIX + key);
};

export const removeFeedbackStorageKeys = () => {
  FEEDBACK_STORAGE_KEYS.forEach(removeFromStorage);
};
export const isFeedbackExist = (feedbacks, user) => {
  // Herotolk users don't use star rating — deviation is given only once
  if (isHeroBrandEnabled()) {
    return Boolean(feedbacks?.length);
  }
  return Boolean(feedbacks?.some(({ userId, starsGeneral, starsTechnical, starsUser }) => {
    const sameUser = userId === user?.id;
    const noRating = !starsGeneral && !starsTechnical && !starsUser;
    return sameUser && !noRating;
  }));
};
